import { render, staticRenderFns } from "./DeepLinkRedirect.vue?vue&type=template&id=7553ef0e&scoped=true&"
import script from "./DeepLinkRedirect.vue?vue&type=script&lang=js&"
export * from "./DeepLinkRedirect.vue?vue&type=script&lang=js&"
import style0 from "./DeepLinkRedirect.vue?vue&type=style&index=0&id=7553ef0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7553ef0e",
  null
  
)

export default component.exports